import React from 'react';
import { motion } from 'framer-motion';
import { Container, Typography, Button, Grid, Paper } from '@mui/material';

const Home = ({ setView }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Container maxWidth="md">
        <Paper className="glass-card">
          <Typography variant="h2" component="h1" gutterBottom>
            What's Best For Me?
          </Typography>
          <Typography variant="h5" component="p" gutterBottom>
            Find the perfect career, pet, or vacation with our fun and interactive quizzes and flowcharts.
          </Typography>
          <Grid container spacing={2} justifyContent="center" className="mt-4">
            <Grid item>
              <Button variant="contained" color="primary" onClick={() => setView('careerQuiz')}>
                Career Quiz
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" color="secondary" onClick={() => setView('petFlowchart')}>
                Pet Flowchart
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </motion.div>
  );
};

export default Home;
